"use strict";

import * as bootstrap from 'bootstrap';
import { gsap } from 'gsap';

window.bootstrap = bootstrap; // ora puoi usare window.bootstrap.Tooltip ecc.
window.gsap = gsap;

export { bootstrap, gsap };
